export const lt = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Atgal",
        save: "Išsaugoti",
        saved: "Išsaugota",
        cancel: "Atšaukti",
        close: "Uždaryti",
        accessDenied: "Prieiga Atmesta",
        noExportPermission: "Neturite leidimo eksportuoti šių automobilių duomenų.",
        delete: "Ištrinti",
        downgrade: "Sumažinti",
        downgradeConfirm: "Ar tikrai norite pereiti prie nemokamo plano?",
        edit: "Redaguoti",
        loading: "Kraunama...",
        confirm: "Patvirtinti",
        processing: "Apdorojama...",
        history: "Istorija",
        currentCar: "Dabartinis automobilis",
        purchasedCarTitle: "Automobilio Pirkimas",
        initialCost: "Pradinė Kaina",
        done: "Baigta",
        ok: "Gerai",
        error: "Klaida",
        errorSaving: "Klaida išsaugant duomenis",
        mandatoryFieldsError: "Prašome teisingai užpildyti visus privalomus laukus.",
        search: "Ieškoti",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Neteisingas el. pašto formatas",
        today: "Šiandien",
        car: "Automobilis",
        all: "Visi",
        deleteConfirm: "Ištrinti",
        unsavedChangesTitle: "Nepatvirtinti Pakeitimai",
        unsavedChangesMessage: "Ar norite išsaugoti pakeitimus prieš išeidami?",
        dontSave: "Neišsaugoti",
        additionalOptions: "Papildomi pasirinkimai",
        add: "Pridėti",
        fileTooLarge: "Failas per didelis. Maksimalus dydis yra {limit} MB.",
        storageFull: "Pasiekta saugojimo riba. Maksimalus saugojimas yra {limit} MB.",
        dailyUploadLimit: "Pasiektas dienos įkėlimų limitas ({limit} failų/dieną). Bandykite rytoj.",
        hourlyUploadLimit: "Pasiektas valandos įkėlimų limitas ({limit} failų/val.). Bandykite po valandos.",
        fileCountLimit: "Maksimalus {limit} failų leidžiamas vienam elementui.",
        emailParseLimitReached: "Pasiekta el. pašto analizavimo riba. Prašome atnaujinti savo planą arba apdoroti rankiniu būdu.",
        emailLimitText: "Pasiekta el. pašto apdorojimo riba.",
        monthlyEmailScans: "Mėnesiniai el. pašto nuskaitymai (Pro)",
        lifetimeEmailScans: "Viso gyvenimo el. pašto nuskaitymai (Nemokamai)",
        monthlyFileScans: "Mėnesiniai kvitų nuskaitymai (Pro)",
        lifetimeFileScans: "Viso gyvenimo kvitų nuskaitymai (Nemokamai)",
        fileLimitText: "Pasiektas kvitų nuskaitymo limitas.",
        planFreeTier: "Nemokamas planas",
        planProTier: "Pro planas",
        uploadFailed: "Įkėlimas nepavyko",
        attachments: "Prisegimai",
        limitsAndUsage: "Limitai ir Naudojimas",
        addresses: "adresai",
        emailCopied: "El. pašto adresas nukopijuotas!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Įtrauktas",
        proOnly: "TIK PRO",
        month: "mėn",
        openInNewTab: "Atidaryti naujame skirtuke",
        menu: "Meniu",
        home: "Pradžios",
        monthsShort: {
            0: "Sau",
            1: "Vas",
            2: "Kov",
            3: "Bal",
            4: "Geg",
            5: "Bir",
            6: "Lie",
            7: "Rgp",
            8: "Rgs",
            9: "Spa",
            10: "Lap",
            11: "Gru",
        },
    },
    carMetadata: {
        bodyType: "Kėbulo tipas",
        drivetrain: "Pavarų sistema",
        transmission: "Pavarų dėžė",
        bodyTypes: {
            sedan: "Sedanas",
            hatchback: "Hatchback",
            wagon: "Kombis",
            suv: "SUV",
            crossover: "Krosoveris",
            coupe: "Kupė",
            convertible: "Kabrioletas",
            pickup: "Pickup",
            van: "Furgonas / Minivenas",
            commercial: "Komercinis",
            other: "Kitas",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "FWD",
            rwd: "RWD",
            awd: "AWD / 4x4",
            other: "Kita",
        },
        transmissions: {
            not_specified: "-",
            manual: "Mechaninė",
            automatic: "Automatinė",
            cvt: "CVT",
            other: "Kita",
        },
        otherLabel: "Kitas (nurodykite)",
        mileageLabel: "Rida",
    },
    auth: {
        welcome: "Sveiki atvykę",
        welcomeBack: "Sveiki sugrįžę",
        signIn: "Prisijungti",
        signInWithGoogle: "Prisijungti su Google",
        signOut: "Atsijungti",
        magicLinkDesc: "Gaukite magišką nuorodą savo el. pašte",
        magicLinkSent: "Magiška nuoroda išsiųsta!",
        magicLinkCheckEmail: "Patikrinkite savo el. paštą ir spustelėkite nuorodą, kad prisijungtumėte.",
        emailAddress: "El. pašto adresas",
        getMagicLink: "Gauti magišką nuorodą",
        sending: "Siunčiama...",
        linkSent: "Nuoroda išsiųsta",
        orContinueWith: "Arba tęskite su",
        googleAccount: "Google paskyra",
        newUserNote: "Naujas čia? Jūsų paskyra bus sukurta automatiškai po pirmo sėkmingo prisijungimo.",
        magicLinkError: "Nepavyko išsiųsti magiškos nuorodos. Patikrinkite savo el. paštą ir bandykite dar kartą.",
        genericError: "Įvyko klaida. Prašome bandyti dar kartą.",
        projectDescription: "Sekite savo automobilio išlaidas, priežiūrą ir istoriją vienoje vietoje.",
        loginError: "Nepavyko prisijungti",
        loggingIn: "Prisijungia...",
        authenticating: "Autentifikavimas...",
        authenticatingDesc: "Prašome palaukti, kol užtikrinsime jūsų sesiją.",
    },
    settings: {
        title: "Nustatymai",
        systemPreferences: "Sistemos Nustatymai",
        appSettings: "Programėlės Nustatymai",
        dangerZone: "Pavojinga Zona",
        theme: "Tema",
        language: "Sąsajos Kalba",
        currency: "Valiuta",
        units: "Vienetai",
        distanceUnit: "Atstumo Vienetas",
        volumeUnit: "Tūrio Vienetas",
        expenseTypes: "Išlaidų Tipai",
        expenseTypesDesc: "Tvarkyti kategorijas",
        categories: "Kategorijos",
        exportData: "Eksportuoti Duomenis",
        exportDesc: "Atsisiųsti išsamią CSV",
        importData: "Importuoti Duomenis",
        importDesc: "Atkurti iš CSV atsarginės kopijos",
        deleteAccount: "Ištrinti Paskyrą",
        deleteAccountDesc: "Visam laikui pašalinti visus duomenis",
        enableSync: "Įjungti Sinchronizavimą",
        enableSyncDesc: "Sinchronizuoti duomenis tarp įrenginių",
        account: "Paskyra",
        accountPlan: "Paskyros planas",
        carsUsage: "Automobiliai",
        carsLimitReached: "Pasiektas automobilių limitas",
        storageSize: "Saugojimo dydis",
        emailScans: "El. pašto nuskaitymai",
        fileScans: "Kvito nuskaitymai",
        plans: "Planai",
        currentlyPlan: "Šiuo metu",
        upgradePlan: "Atnaujinti",
        manageSubscription: "Valdyti prenumeratą",
        nextPayment: "Kitas mokėjimas",
        endsOn: "Baigiasi",
        adminConsole: "Administratoriaus Konsolė",
        systemControl: "Sistemos Valdymas",
        customCategories: "Pritaikytos Kategorijos ir Etiketės",
        interfaceTheme: "Sąsajos Tema",
        light: "Šviesi",
        dark: "Tamsi",
        timezone: "Laiko zona",
        timezoneDesc: "Naudojama suplanuotiems el. pašto priminimams",
        timeFormat: "Laiko formatas",
        timeFormat24h: "24 valandų (14:30)",
        timeFormat12h: "12 valandų (2:30 PM)",
        kilometers: "kilometrai (km)",
        miles: "mylios (mi)",
        liters: "litrai (l)",
        gallons: "galonai (gal)",
        accountManagement: "Paskyros Valdymas",
        contactUs: "Susisiekite su mumis",
        contactDesc: "Dėl pasiūlymų, funkcijų prašymų ir klausimų",
        logOut: "Atsijungti",
        logOutConfirmTitle: "Atsijungti",
        logOutConfirmMessage: "Ar tikrai norite atsijungti nuo savo paskyros?",
        keepAccount: "Išlaikyti Paskyrą",
        deleteAccountConfirmTitle: "Ištrinti Paskyrą",
        deleteAccountConfirmMessage: "Ar tikrai norite visam laikui ištrinti savo paskyrą ir visus susijusius automobilio duomenis? Šios operacijos negalima atšaukti.",
        deletePermanently: "Ištrinti Visam Laikui",
        deleting: "Ištrinama...",
        contactSupport: "Susisiekti su Pagalba",
        messageSent: "Žinutė Išsiųsta!",
        feedbackThanks: "Ačiū už jūsų atsiliepimą. Vertiname jūsų nuomonę ir ją apsvarstysime.",
        backToSettings: "Atgal į Nustatymus",
        subjectLabel: "Tema",
        messageLabel: "Žinutė",
        subjectPlaceholder: "Apie ką tai?",
        messagePlaceholder: "Pasakykite mums apie savo pasiūlymą, funkcijų prašymą ar klausimą...",
        enterSubjectAlert: "Prašome įvesti temą",
        enterMessageAlert: "Prašome įvesti žinutę",
        sendFailedAlert: "Nepavyko išsiųsti žinutės. Prašome bandyti vėliau.",
    },
    export: {
        title: "Eksportuoti Duomenis",
        generatePDF: "Generuoti PDF",
        carInformation: "Automobilio Informacija",
        editInfo: "Redaguokite žemiau pateiktą informaciją, kad pritaikytumėte savo eksportą",
        editInfoHint: "Galite pašalinti arba pakeisti bet kuriuos laukus, kurių nenorite įtraukti",
        filters: "Filtrai",
        expenseTypes: "Išlaidų Tipai",
        includeNotes: "Įtraukti Pastabas",
        includeImages: "Įtraukti Vaizdus ir Failus",
        hideDisabled: "Slėpti Neaktyvius Elementus",
        itemsCount: "{total} elementai, {selected} pasirinkti",
        selectAll: "Pasirinkti Viską",
        deselectAll: "Atšaukti Viską",
        expenses: "Išlaidos",
        notes: "Pastabos",
        spareParts: "Atsarginės Dalys",
        images: "Vaizdai",
        files: "Failai",
        summary: "Santrauka",
        totalExpenses: "Bendros Išlaidos",
        totalItems: "Bendras Elementų Skaičius",
        generatedOn: "Sugeneruota",
        noItemsSelected: "Nėra pasirinkta elementų eksportui",
        noItemsAvailable: "Nėra elementų, kuriuos galima eksportuoti",
        generating: "Generuojama PDF...",
        downloadPDF: "Atsisiųsti PDF",
        pdfFileName: "{carName}_eksportas_{date}.pdf",
        reportTitle: "Automobilio Išlaidų Ataskaita",
        exportButton: "Eksportuoti",
        generateCSV: "Generuoti CSV",
        formatSelectorTitle: "Pasirinkite formatą",
        formatSelectorMsg: "Pasirinkite eksporto formatą",
        proFeatureExportTitle: "Pro funkcija: Eksportuoti duomenis",
        proFeatureExportDesc: "Atsinaujinkite į PRO, kad eksportuotumėte savo automobilio istoriją į PDF.",
        exportRestrictedPopup: "Duomenų eksportas prieinamas tik PRO vartotojams.",
        allTypes: "Visi Tipai",
        statistics: "Statistika",
        driven: "Nuvažiuota",
        since: "Nuo",
        averageCost: "Vidutinė Kaina",
        perKm: "už km",
        perMile: "už myli",
        period: "Laikotarpis",
        dateFrom: "Nuo",
        dateTo: "Iki",
        allTime: "Išvalyti filtrą",
        periodHint: "Jei laikotarpis nėra pasirinktas — rodomi visi išlaidos",
        noExpenses: "Nėra išlaidų, atitinkančių filtrus",
        expensesSection: "Išlaidos",
        attachmentsSection: "Prisegimai",
        imagesCount: "{count} nuotraukos",
        pdfsCount: "{count} PDF",
        includeParts: "Įtraukti atsargines dalis",
        pageLabel: "Puslapis",
    },
    expenses: {
        title: "Išlaidos",
        newExpense: "Nauja Išlaida",
        editExpense: "Redaguoti Išlaidą",
        openExpense: "Atidaryti išlaidų įrašą",
        details: "Išlaidų Detalės",
        selectType: "Pasirinkti Tipą",
        selectTypePlaceholder: "Pasirinkite išlaidų tipą...",
        shortDescriptionPlaceholder: "Trumpas aprašymas...",
        expenseTitle: "Pavadinimas",
        logEntryTitleLabel: "Įrašo pavadinimas (nebūtina)",
        defaultTitlePlaceholder: "Pagal nutylėjimą - {type}",
        autoTitlePlaceholder: "Bus užpildyta automatiškai pagal pasirinktus tipus",
        carDataTitle: "Automobilio duomenys",
        defaultTitlePrefix: "Numatytas pavadinimas bus -",
        addAnother: "Pridėti kitą išlaidų rūšį",
        addAnotherHint: "Jei šis įrašas apima kelias išlaidų rūšis, galite jas visas pridėti čia, kad statistika būtų tiksli.",
        carValueDescription: "Įvertinta automobilio rinkos vertė šiuo metu.",
        type: "Tipas",
        date: "Data",
        amount: "Suma",
        totalAmount: "Iš viso",
        splitCosts: "Padalinti išlaidas?",
        combineCosts: "Sujungti išlaidas",
        amountWork: "Darbo suma",
        amountParts: "Dalių suma",
        mileage: "Rida",
        carValue: "Automobilio Vertė",
        description: "Aprašymas",
        detailedDescription: "Išsamus aprašymas",
        electricity: "Elektros Energija",
        fuelType: "Kuro Tipas",
        fuelTypeOptions: {
            petrol: "Benzinas",
            diesel: "Dyzelinas",
            lpg: "LPG",
            electricity: "Elektros Energija",
        },
        carData: "Automobilio Duomenys",
        images: "Vaizdai ir Failai",
        addImages: "Pridėti Vaizdus ir Failus",
        addImagesPDFs: "Pridėti Vaizdus arba PDF",
        deleteExpense: "Ištrinti Išlaidą",
        deleteConfirm: "Ar tikrai norite ištrinti šią išlaidą?",
        saveSuccess: "Išlaida sėkmingai išsaugota",
        thisExpense: "Ši išlaida",
        stats: {
            annual: "Metinė",
            allTime: "Visą laiką",
            avgMonth: "Vid./Mėn.",
            costPer: "Kaina/",
            noExpenses: "Dar nėra išlaidų",
            dragToReorder: "Tempkite rankenėlę, kad pertvarkytumėte",
        },
        expensesFound: "Sukurtos",
        noExpensesFound: "Nėra rasta išlaidų.",
        noDescription: "Nėra aprašymo",
        imagesCount: "Vaizdai ({count})",
        deleteImageTitle: "Ištrinti Vaizdą",
        deleteImageConfirm: "Ar tikrai norite ištrinti šį vaizdą? Šios operacijos negalima atšaukti.",
        typeLabels: {
            fuel: "Kuras",
            car_wash: "Plovimas",
            repairs: "Remontas",
            maintenance: "Priežiūra",
            parts: "Atsarginės Dalys",
            insurance: "Draudimas",
            inspection: "Techninė Apžiūra",
            tyres: "Padangos",
            parking: "Parkavimas",
            electricity: "Elektros Energija",
            taxes: "Mokesčiai",
            other: "Kita",
            info: "Informacija",
            service_maintenance: "Priežiūra",
            service_repair: "Remontas",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Servisas",
            selectSubtype: "Pasirinkite tipą",
            maintenance: "Priežiūra",
            repair: "Remontas",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Kartojantis išlaidas",
        repeatToggle: "Kartoti šią išlaidą",
        repeatFrequency: "Dažnumas",
        monthly: "Mėnesinis",
        startDate: "Pradžios data",
        nextDate: "Kitas įrašas bus sugeneruotas",
        endDate: "Pabaigos data",
        noEndDate: "Be pabaigos datos",
        copyOptions: "Kopijavimo parinktys",
        copyTitle: "Kopijuoti įrašo pavadinimą",
        copyLocation: "Kopijuoti vietą",
        copyDescription: "Kopijuoti aprašymą",
        active: "Aktyvus",
        status: "Būsena",
        managedByRepeat: "Ši išlaida yra dalis kartojančios sekos.",
        placeholder: "Čia galite nustatyti automatinį šios išlaidos kartojimą, jei ji vyksta reguliariai su ta pačia suma.",
        deleteRepeat: "Ištrinti kartojimą",
        deleteRepeatConfirm: "Ar tikrai norite sustabdyti ir ištrinti šią kartojančią seką? Ateities įrašai nebus sugeneruoti. Praeities įrašai liks.",
        relatedEntries: "Įrašai šioje sekoje",
        stopRepeat: "Sustabdyti kartojimą",
        isRepeating: "Kartojama",
        noTerm: "Neribotai",
        until: "Paskutinis įrašas bus sugeneruotas",
        summaryCopy: "Sistema nukopijuos",
        simulate: "Simuliuoti kito įrašo generavimą",
        simulateSuccess: "Sėkmingai simuliuotas kito įrašo generavimas",
        simulateNoDate: "Nėra daugiau datų generavimui (pasiekta pabaigos data)",
    },
    onboarding: {
        title: "Profilio Nustatymas",
        welcome: "Sveiki atvykę!",
        subtitle: "Pridėkite savo vairavimo patirtį.",
        currency: "Valiuta",
        preferredCurrency: "Pageidaujama Valiuta",
        distUnit: "Atstumo Vienetas",
        volUnit: "Tūrio Vienetas",
        complete: "Baigti Nustatymą",
    },
    cars: {
        unitChangeWarningTitle: "Įspėjimas apie vienetų keitimą",
        unitChangeWarningMessage: "Keičiant šiuos vienetus, jūsų esami duomenys nebus konvertuoti. Visi istoriniai įrašai liks tiksliai tokie, kokie buvo įvesti.",
        unitChangeWarningConfirm: "Supratau",
        title: "Garažas",
        carAdmins: "Automobilių administratoriai",
        sharedWithMe: "Bendrai su manimi",
        manageAdmins: "Tvarkyti administratorius",
        adminEmail: "Administratorius el. paštas",
        addAdmin: "Pridėti administratorių",
        addAdminPlaceholder: "pvz. draugas@email.com",
        removeAdmin: "Pašalinti",
        removeAdminConfirm: "Ar tikrai norite pašalinti šį administratorių?",
        adminAdded: "Administratorius pridėtas",
        adminRemoved: "Administratorius pašalintas",
        removeMyAccess: "Pašalinti mano prieigą",
        removeMyAccessConfirm: "Ar tikrai norite atsisakyti prieigos prie šio automobilio?",
        myAccessRemoved: "Prieiga pašalinta",
        noAdminsYet: "Dar nėra pridėtų administratorių.",
        adminInfoText: "Administratoriai gali pridėti ir redaguoti išlaidas, pastabas ir atsargines dalis, tačiau negali ištrinti paties automobilio.",
        newCar: "Pridėti Automobilį",
        carNotFound: "Automobilis nerastas",
        carNotFoundDesc: "Prašomas automobilis neegzistuoja arba neturite prieigos.",
        accessDenied: "Prieiga atimta",
        accessDeniedDesc: "Šis automobilis yra privatus ir nėra viešai prieinamas.",
        backToHome: "Grįžti į pradžią",
        adminRestricted: "Prieiga apribota",
        adminRestrictedDesc: "Tik įgalioti administratoriai gali pasiekti šią konsolę. Prašome grįžti į pagrindinę programą.",
        returnHome: "Grįžti namo",
        editCar: "Redaguoti Automobilį",
        name: "Automobilio Pavadinimas",
        model: "Modelis",
        year: "Metai",
        plate: "Valstybinis Numeris",
        vin: "VIN Numeris",
        mileage: "Dabartinis rida",
        initialMileage: "Pradinė rida",
        engineType: "Variklio tipas",
        tapToChangeIcon: "Paspauskite, kad pakeistumėte ikoną",
        chooseIcon: "Pasirinkite ikoną",
        imageTab: "Paveikslėlis",
        iconTab: "Ikona",
        chooseColor: "Pasirinkite spalvą",
        chooseEmoji: "Pasirinkite emodžį",
        uploadImage: "Įkelti paveikslėlį",
        clickToBrowse: "Paspauskite, kad naršytumėte failus",
        currentCarIcon: "Dabartinė automobilio ikona",
        changeImage: "Keisti paveikslėlį",
        zoom: "Priartinti",
        rotate: "Sukti",
        removeChangeImage: "Pašalinti / Keisti paveikslėlį",
        selectIcon: "Pasirinkite ikoną",
        cropAndSave: "Iškirpti ir išsaugoti",
        displayName: "Rodomas pavadinimas",
        displayNamePlaceholder: "pvz. Mano savaitgalio automobilis",
        makeLabel: "Gamintojas *",
        modelLabel: "Modelis *",
        yearLabel: "Metai *",
        fuelTypeLabel: "Tipas *",
        licensePlateLabel: "Valstybinis numeris",
        vinLabel: "VIN",
        notesLabel: "Pastabos (neprivaloma)",
        notesPlaceholder: "pvz. 1.6 TDI, 85kW, 1588cc, baterija 62kWh, AWD ir kt.",
        publicAccess: "Padaryti automobilį viešai prieinamą",
        publicAccessDesc: "Kiti gali peržiūrėti šį automobilį per bendrinamą nuorodą",
        shareLocations: "Leisti matyti pridėtas vietas",
        shareLocationsDesc: "Įgalinkite tai, kad automobilio vietos būtų matomos viešai",
        deleteCar: "Ištrinti automobilį",
        deleteCarTitle: "Ištrinti automobilį",
        deleteCarConfirm: "Ar tikrai norite ištrinti '{name}'? Šios operacijos negalima atšaukti.",
        noCars: "Jūsų garaže nėra automobilių",
        addFirstCarNote: "Pradėkite savo kelionę pridėdami pirmąjį transporto priemonę, kad galėtumėte sekti išlaidas.",
        addVehicle: "Pridėti transporto priemonę",
        myVehicles: "Mano transporto priemonės",
        favorites: "Mėgstamiausi",
        deleteConfirm: "Ar tikrai norite ištrinti šį automobilį? Visos susijusios išlaidos bus ištrintos.",
        deleteFailed: "Nepavyko ištrinti automobilio",
        saveFailed: "Nepavyko išsaugoti automobilio duomenų",
        adminActions: "Administratoriaus veiksmai",
        importCsv: "Importuoti CSV",
        clearData: "Išvalyti duomenis",
        distanceUnitLabel: "Atstumo vienetas",
        volumeUnitLabel: "Tūrio vienetas",
        currencyLabel: "Valiuta",
        boughtAt: "Pirkimo data",
        purchasePrice: "Pirkimo kaina",
        purchaseMileage: "Pirkimo rida",
        createPurchaseRecord: "Automatiškai sukurti pirkimo istorijos įrašą",
        makePlaceholder: "pvz. BMW",
        modelPlaceholder: "pvz. X5",
        platePlaceholder: "pvz. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Ši informacija sukurs pradinį 'Informacijos' įrašą jūsų istorijoje su nurodytais duomenimis.",
        availableTypes: "Galimi tipai",
        dragToReorder: "Vilkti, kad pertvarkytumėte",
        requestTypeNote: "Jei jums reikia kito tipo - ",
        requestTypeAction: "praneškite mums!",
        emailProcessingTitle: "El. pašto apdorojimas",
        emailInstructions: "Persiųskite savo kvitus į žemiau nurodytą adresą. Mes išgauti duomenis ir automatiškai sukursime išlaidas.",
        recentEmails: "Gauti el. laiškai",
        viewAllEmails: "PERŽIŪRĖTI VISUS ({count})",
        noEmailsReceived: "Dar negauta jokių el. laiškų.",
        analysisResult: "Analizės rezultatas",
        vehicleInfo: "Transporto priemonės informacija",
        preferences: "Nustatymai",
        purchaseHistory: "Pirkimo istorija",
        emailProcessing: "El. pašto apdorojimas",
        publicAccessTitle: "Viešas prieinamumas",
        expenseTypesTitle: "Išlaidų tipai",
        adminActionsTitle: "Administratoriaus veiksmai",
        enterPurchaseDateAlert: "Prašome įvesti pirkimo datą",
        allowedSenderEmails: "Leidžiami siuntėjų el. paštai",
        allowedEmailsDesc: "Pridėkite el. pašto adresus, kurie gali siųsti kvitus šiam automobiliui. Maksimaliai 5 adresai.",
        noAllowedEmails: "Nėra pridėtų leidžiamų el. paštų.",
        emailAlreadyAdded: "Šis el. paštas jau leidžiamas šiam automobiliui.",
        maxAllowedEmailsReached: "Pasiektas maksimalus leidžiamų el. paštų limitas.",
        addAllowedEmailPlaceholder: "Pridėti leidžiamą el. paštą...",
        ownerEmail: "Savininkas",
        onlyOwner: "tik savininkui",
        defaultAllowed: "Visada leidžiama",
        carLimitReachedTitle: "Pasiektas automobilių limitas",
        carLimitReachedMessage: "Jūsų {plan} planas leidžia {limit} automobilį(-ius). Jau turite {current}. Eikite į nustatymus, kad pamatytumėte savo limitus, arba susisiekite su mumis, kad atnaujintumėte.",
        carLimitGoToSettings: "Eiti į nustatymus",
        archivedCars: "Archyvuoti",
        archiveCar: "Archyvuoti automobilį",
        unarchiveCar: "Atarchyvuoti automobilį",
        sellDate: "Pardavimo data",
        sellPrice: "Pardavimo kaina",
        sellMileage: "Pardavimo rida",
        archiveConfirm: "Ar tikrai norite archyvuoti šį automobilį?",
        archiveInstructions: "Archyvuoti automobilį reiškia, kad jis nebe jūsų arba jūs jo nebeprižiūrite. Prašome pateikti pardavimo detales statistikai. Tai padarys automobilį tik skaitymui.",
        archivedBadge: "Archyvuota",
        saleDetails: "Pardavimo detalės",
        saleDetailsNote: "Pardavimo detalės naudojamos statistikai. Galite jas atnaujinti, jei reikia.",
        archiveDetailsNotFillable: "Prašome užpildyti visus laukus, kad archyvuotumėte automobilį",
        emailAddressWillBeAvailableAfterSave: "El. pašto adresas bus prieinamas išsaugojus automobilį.",
        proFeatureAdminTitle: "Pro funkcija: Automobilio administratoriai",
        proFeatureAdminDesc: "Pridėkite kitus vartotojus, kurie gali peržiūrėti ir valdyti šiuos automobilio duomenis.",
        proFeatureEmailTitle: "Pro funkcija: Papildomi siuntėjai",
        proFeatureEmailDesc: "Pridėkite kitus leidžiamus el. pašto adresus, iš kurių gali būti siunčiami kvitai šiam automobiliui.",
        estimatedMileage: "Numatomas nuvažiuotas atstumas",
        summaryFrequencyLabel: "Santraukos dažnis",
        summaryFrequencyOptions: {
            none: "Išjungta",
            monthly: "Mėnesinis",
            semiAnnually: "Kas šešis mėnesius",
            annually: "Kasmet",
        },
        healthProfilePrompt: "Užpildykite savo sveikatos profilį tiksliam analizei!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Benzinas",
        diesel: "Dyzelinas",
        hybrid: "Hibridas",
        electric: "Elektrinis",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Ridos tendencija",
        title: "Statistika",
        allYears: "Visi metai",
        totalSpent: "Iš viso išleista",
        spentIn: "Išleista {year}",
        perMonth: "per mėnesį",
        overall: "iš viso",
        vsPrev12m: "palyg. 12mēn.",
        rolling12m: "Pask. 12mēn.",
        byType: "Pagal tipą",
        byMonth: "Pagal mėnesį",
        byYear: "Pagal metus",
        noData: "Nėra duomenų šiems metams",
        mostExpensive: "Brangiausias",
        top: "Geriausi",
        untitled: "Be pavadinimo",
        assetAnalysis: "Turto vertės ir sąnaudų analizė",
        burnNote: "* 'Bendra degimo suma' apima tiek išleistas pinigų sumas, tiek numatomą automobilio vertės sumažėjimą.",
        carMarketValue: "Automobilio rinkos vertė",
        cumulativeCosts: "Kaupiamosios sąnaudos",
        totalBurn: "Bendra degimo suma (Sąnaudos + Amortizacija)",
        entries: "įrašai",
        avgPrice: "Vidutinė kaina",
        consumption: "Sąnaudos",
        price: "Kaina",
        fuelPriceTrend: "Kuro kainų tendencija",
        spendingTrend: "Išlaidų tendencija",
        costPerKmTrend: "Kaina už 1 km",
        costPerMileTrend: "Kaina už 1 myli",
        serviceTrendsTitle: "Serviso Tendencijos",
        expensesOnMap: "Išlaidos žemėlapyje",
        visitsCountLabel: "apsilankymai",
        locationsSummary: "Vietų santrauka",
        locationsCountLabel: "vietos",
        noLocationsFoundTitle: "Vietų dar nėra",
        noLocationsFoundDesc: "Pridėkite vietas prie savo įrašų, kad jas matytumėte žemėlapyje.",
        addMileageData: "Pridėti ridos duomenis",
        missingMileageInfo: "Nepakanka duomenų, kad būtų galima apskaičiuoti kainą už atstumą. Pridėkite bent 2 ridos rodmenis šiuo laikotarpiu (arba vieną prieš šį laikotarpį).",
        mileageModal: {
            title: "Pridėti trūkstamą ridą",
            description: "Norint tiksliai apskaičiuoti išlaidas už atstumą {year}, mums reikia žinoti ridą metų pradžioje ir pabaigoje.",
            startOfYear: "Metų pradžia (Sausio 1 d.)",
            endOfYear: "Metų pabaiga (Gruodžio 31 d.)",
            currentMileage: "Dabartinė rida",
            placeholder: "Įveskite ridą...",
            save: "Išsaugoti duomenis",
            foundNearby: "Rasta netoliese ({date}): {value} {unit}",
            useExisting: "Naudoti šį",
        },
        proAnalysis: "Pro analizė",
        detailedAnalysis: "Išsami analizė",
        upgradeToSee: "Atsinaujinkite, kad pamatytumėte →",
    },
    tabs: {
        dashboard: "Valdymo pultas",
        expenses: "Išlaidos",
        stats: "Statistika",
        locations: "Vietos",
        gallery: "Gallery",
        parts: "Dalys",
        notes: "Pastabos",
        repair: "Remonto režimas",
        'repair-switch': "Automobilio perjungimas",
    },
    repairAnalysis: {
        title: "Remonto sprendimo analizė",
        ownershipLength: "Nuosavybės trukmė",
        currentValue: "Dabartinė vertė",
        valueOutdated: "Vertė gali būti pasenusi",
        addValueToEnable: "Pridėkite dabartinę automobilio vertę, kad įgalintumėte analizę",
        totalInvested: "Iš viso investuota",
        totalInvestedSub: "Pirkimo kaina + remontai",
        totalExcludesFuel: "neįskaičiuojant degalų / elektros",
        fuelLabelFuelOnly: "Deguonies suma",
        fuelLabelEnergyOnly: "Energijos suma",
        fuelLabelHybrid: "Deguonies ir energijos suma",
        fuelTypeFuel: "degalai",
        fuelTypeEnergy: "elektra",
        fuelTypeHybrid: "degalai ir elektra",
        fuelTotalLabel: "Kuro/Energijos suma:",
        projectionMode: "Prognozavimo režimas",
        projectionModes: {
            lastYear: "Remiantis praėjusiais metais",
            average: "Istorinis vidurkis",
            trend: "Tendencija (linijinė)",
        },
        brakeAssumption: "Priežiūra apima numatomą 3 metų stabdžių ciklą",
        repairBuffer: "Įtraukta amžiaus pagrindu nustatyta remonto rizikos atsarga",
        yearLabel: "metai",
        totalInvestedDesc: "Pirkimo kaina + visi remontai",
        repairToValue: "Remontas iki vertės (12m)",
        repairToValueExplain: "Remontai €{cost} prieš automobilio vertę €{value}. Po 20% yra sveika; virš 50% yra didelė rizika.",
        ownershipPressure: "Savininkystės spaudimas",
        ownershipPressureExplain: "Bendra išlaidų spaudimas: remontai €{cost} + vertės nuostolis prieš €{value}. Virš 35% signalizuoja finansinį stresą.",
        investmentGap: "Investicijų spraga",
        investmentGapExplain: "Iš viso investuota €{invested} minus dabartinė vertė €{value}. Tai rodo, kiek jūs 'praradote' dėl savininkystės iki šiol.",
        investmentGapDesc: "Iš viso investuota - dabartinė vertė",
        repairExpenses12m: "12m Remonto kaina",
        calculatedYearlyMileage: "Apskaičiuotas metinis rida: {km} km",
        calculatedYearlyRepairs: "Apskaičiuoti metiniai remontai: {amount}",
        set: "Nustatyti",
        plannedRepairCost: "Planuojama remonto kaina",
        whatIfTitle: "Ką jei dabar išleisite {amount}?",
        updatedScore: "Atnaujintas balas",
        updatedVerdict: "Atnaujintas verdiktas",
        howIsItCalculated: "Kaip tai apskaičiuojama?",
        usedLifespan: "Naudota: {usage}% numatomo tarnavimo laiko",
        remainingLifespan: "Liko: ~{km} km",
        estimatedLifespan: "Numatomas tarnavimo laikas: {km} km",
        lifecycle_stage_early: "Ankstyvas gyvenimo ciklas – mažas didelių gedimų rizika",
        lifecycle_stage_mid: "Vidurinis gyvenimo ciklas – normalus nusidėvėjimas",
        lifecycle_stage_late: "Vėlyvas gyvenimo ciklas – padidėjusi remonto rizika",
        lifecycle_stage_end: "Numatomo tarnavimo laiko pabaiga – didelė didelių remontų rizika",
        calculationExplanation: "Analizė naudoja jūsų transporto priemonės pirkimo kainą, neseniai atliktų remontų išlaidas ir numatomą dabartinę vertę, kad apskaičiuotų finansinės sveikatos balą. Didelės remonto išlaidos, palyginti su automobilio verte, arba greitas nuvertėjimas sumažins balą.",
        confidenceLabel: "Pasitikėjimas",
        confidenceLevel: {
            high: "Aukštas",
            medium: "Vidutinis",
            low: "Žemas",
        },
        mentalFactorsTitle: "Pagerinkite tikslumą su savo patirtimi",
        mentalFactorsCTA: "Greitas patikrinimas (30 sek.)",
        mentalFactorsSurveyTitle: "Jūsų Patirtis",
        mentalFactorsSurveyDesc: "Atsakykite į 3 greitus klausimus, kad suasmenintumėte savo balą.",
        q1: "Ar jūsų automobilis atitinka jūsų poreikius?",
        q1Help: "Erdvė, komfortas, funkcijos",
        q2: "Ar jums patinka vairuoti savo automobilį?",
        q2Help: "Vizualus, komfortas, jausmas",
        q3: "Ar nerimaujate dėl netikėtų gedimų?",
        q3Help: "Patikimumo problemos",
        q4: "Ar šis automobilis skirtas šeimai ir ilgoms kelionėms?",
        q4Help: "Saugumo ir patikimumo prioritetas",
        factorsTitle: "Balų veiksniai",
        factorsDesc: "Žiūrėkite, kas daro įtaką jūsų balui",
        newCarComparison: "Naujo automobilio palyginimas",
        newCarComparisonDesc: "Palyginkite savo dabartines mėnesines išlaidas su naujo automobilio pirkimu.",
        modeLeasing: "Lizingas",
        modeFullPrice: "Visiška kaina",
        downPayment: "Pradinė įmoka",
        leaseYears: "Terminas (metai)",
        monthlyPayment: "Mėnesinė įmoka",
        carPrice: "Automobilio pilna kaina",
        ownershipYears: "Planuojama savininkystė (metai)",
        insuranceMonthly: "Mėnesinė CASCO / Draudimas",
        currentMonthlyCost: "Dabartinės automobilio išlaidos",
        newCarMonthlyCost: "Naujo automobilio išlaidos",
        newCarCheaper: "Naujas automobilis pigesnis: {amount} / mėn",
        newCarMoreExpensive: "Naujas automobilis brangesnis: {amount} / mėn",
        newCarSameCost: "Kainos visiškai tokios pačios.",
        advancedSettings: "Išplėstiniai nustatymai",
        yearlyMaint: "Metinės priežiūros išlaidos (€)",
        tyres3Yrs: "Padangos / 3m (€)",
        depreciation5Yrs: "Amortizacija (5 m %)",
        newCarYear: "Naujo automobilio metai",
        cumulativeCosts: "Kaupiamos išlaidos (prognozė)",
        comparisonByYear: "Palyginimas pagal metus",
        currentCarLabel: "Dabartinis automobilis",
        newCarLabel: "Naujas automobilis",
        resaleValue: "Perpardavimo vertė",
        startupCosts: "Pradinės išlaidos (naudotas automobilis)",
        inspection: "Priešpirkimo patikra",
        initialMaintenance: "Pradinė priežiūra + alyvos",
        registration: "Registracija / Mokesčiai",
        total: "Iš viso",
        currentCarTitle: "Dabartinis automobilis",
        newCarTitle: "Potencialus automobilis",
        upfrontInvestment: "Pradinė investicija",
        monthlyReality: "Reali mėnesinė kaina",
        depreciationShort: "Amortizacija",
        howCalculated: "Kaip tai apskaičiuojama?",
        deltaMonthly: "Mėnesinis skirtumas",
        deltaUpfront: "Pradinis skirtumas",
        surveyMeanings: {
            practical: {
                1: "Visai ne",
                2: "Prastas pritaikymas",
                3: "Vidutinis",
                4: "Geras pritaikymas",
                5: "Puikus pritaikymas",
            },
            joy: {
                1: "Nervinantis",
                2: "Nuobodus",
                3: "Vidutinis",
                4: "Malonus",
                5: "Labai malonus",
            },
            worry: {
                1: "Nesijaudinu",
                2: "Šiek tiek jaudinuosi",
                3: "Jaudinuosi",
                4: "Labai jaudinuosi",
                5: "Esu tikras, kad bet kurią akimirką galiu sugesti",
            },
        },
        verdicts: {
            KEEP: "Finansiškai pagrįsta laikyti",
            borderline: "Ribinė – stebėkite atidžiai",
            sell: "Aukštas finansinis rizikos lygis – pardavimas gali būti racionalus",
        },
        factors: {
            trendInc: "Didėjanti tendencija",
            trendIncDesc: "Remonto išlaidos auga palyginti su praėjusiais metais.",
            lowDepreciation: "Maža amortizacijos nauda",
            lowDepreciationDesc: "Senesni/ pigesni automobiliai laikui bėgant praranda mažiau vertės.",
            stableRepairs: "Stabilūs remontai",
            stableRepairsDesc: "Jūsų remonto išlaidos yra stabilios arba mažėjančios.",
            noHistoricalData: "Nėra duomenų, senesnių nei 6 mėnesiai.",
            lifecycle_stage: "Transporto priemonės gyvavimo ciklo etapas",
            high_risk_phase: "Aukštos rizikos etapas",
            high_risk_phase_desc: "Vėlyvo gyvavimo ciklo etapas ir didėjančios remonto išlaidos rodo didelę riziką.",
            lowCostKm: "Efektyvios išlaidos už km",
            lowCostKmDesc: "Bendras šio automobilio eksploatacijos efektyvumas yra puikus.",
            lowFixedCosts: "Mažos fiksuotos išlaidos",
            lowFixedCostsDesc: "Jūsų fiksuotos išlaidos (mokesčiai, draudimas) yra mažos.",
            usage: "Metinis naudojimas",
            usageDesc: "Atstumas, nuvažiavęs per pastaruosius 12 mėnesių.",
            accidentMinor: "Maža avarija",
            accidentMinorDesc: "Kozmetiniai pažeidimai arba maži remontai.",
            structuralDamage: "Struktūriniai pažeidimai",
            structuralDamageDesc: "Rėmo ar struktūriniai problemos žymiai sumažina vertę.",
            aiLifespanNearEnd: "Laukiamo gyvavimo pabaiga",
            aiLifespanAging: "Senstantys komponentai",
            aiLifespanGood: "Maža ridos nauda",
            aiLifespanDesc: "Remiantis AI numatoma tipine šio modelio gyvavimo trukme.",
            aiUpcomingRepairs: "Artėjantys remontai (AI prognozė)",
            aiUpcomingRepairsDesc: "AI prognozuoja, kad netrukus įvyks dideli komponentų gedimai, remiantis rida.",
            ownershipFatigue: "Nuosavybės nuovargis",
            ownershipFatigueLong: "Ilgalaikė nuosavybė dažnai sukelia psichologinį pasirengimą kitam automobiliui.",
            ownershipFatigueShort: "Pradinio nuosavybės šališkumo sukuriama stipresnė tendencija išlaikyti automobilį.",
            family_priority: "Šeima ir Ilgos Kelionės",
            replacement_comparison: "Pakeitimo Palyginimas",
            none: "Nėra",
            surface: "Paviršius",
            minor: "Mažas",
            moderate: "Vidutinis",
            severe: "Sunkus",
            structural: "Struktūrinis",
            major: "Didelis",
            critical: "Kritinis",
            full: "Pilnas",
            improveLabel: "Kas galėtų pagerinti tai:",
            info_original_price: "Apytikslė šio automobilio kaina, kai jis buvo naujas. Padeda įvertinti vertės stabilumą. Senesni automobiliai su mažesne likusia verte yra finansiškai saugesni.",
            info_current_value: "Kiek galėtumėte jį parduoti šiandien. Naudojama patikrinti, ar remontai sudaro didelę procentinę dalį automobilio vertės, kas signalizuoja blogą investiciją.",
            info_yearly_mileage: "Didesnė rida didina nusidėvėjimą. Maža rida gali žymiai prailginti automobilio tarnavimo laiką.",
            info_estimated_repairs: "Nuolatinės išlaidos, susijusios su automobilio veikimu. Didelės metinės išlaidos mažina automobilio išlaikymo patrauklumą.",
            info_planned_repairs: "Žinomi artėjantys remontai. Simuliuoja tiesioginį spaudimą jūsų sprendimui.",
            info_ownership_years: "Kiek laiko turite šį automobilį? Tai veikia psichologinį nuosavybės nuovargį ir pradinio pirkėjo šališkumą.",
            info_rust: "Kritinis ilgalaikis pavojus. Struktūrinis rūdijimas mažina saugumą. Sunkus rūdijimas daro pardavimą geresne galimybe.",
            info_crashes: "Struktūriniai avarijos veikia saugumą ir patikimumą. Jie taip pat žymiai sumažina perpardavimo vertę.",
            info_repaint: "Signalizuoja apie praeities pažeidimus ar kosmetinius remontus. Mažas poveikis, nebent gilesni klausimai buvo paslėpti.",
            info_unresolved: "Paslėptos būsimos išlaidos. Žinomi gedimai elektronikoje, variklyje ar priežiūroje, kuriems reikia dėmesio.",
            info_fit: "Ar automobilis atitinka jūsų poreikius (erdvė, komfortas)? Prastas pritaikymas reiškia, kad labiau tikėtina, jog jį pakeisite.",
            info_joy: "Emocinė vertė yra svarbi. Nėra džiaugsmo reiškia, kad esate psichologiškai pasirengęs naujam automobiliui.",
            info_worry: "Perceived reliability stress. Didelis nerimas yra stiprus signalas pakeisti automobilį.",
        },
        explanations: {
            repairFreq: "Jūsų automobilis per pastaruosius 12 mėnesių turėjo {visits} aptarnavimo vizitų. Dažni vizitai rodo mažesnį patikimumą ir didesnį nepatogumą.",
            repairVsValue: "Per pastaruosius 12 mėnesių jūsų remontai kainavo €{cost}, o automobilio vertė yra €{value}. Tai sudaro {ratio}% visos automobilio vertės.",
            stableRepairsDetailYearly: "Praėjusiais metais jūs išleidote €{cost1} remontams, o prieš metus €{cost2}. Pokytis {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "Paskutinius 6 mėnesius jūs išleidote €{cost1}, ankstesnius 6 mėnesius €{cost2}. Pokytis {percent}% ({trend}).",
            mileage: "Prie {mileage} km automobilis patenka į didesnės rizikos zoną dėl didelių dalių gedimų (transmisija, variklio komponentai).",
            planned: "Turite €{cost} planuojamų remontų, kurie iš karto sumažina finansinį saugumą laikant automobilį.",
            lowDep: "Automobiliai, kurių vertė apie €{value}, per metus praranda labai mažai vertės, kompensuodami didesnes remonto išlaidas.",
            depRisk: "Jūsų automobilis yra {age} metų ir daugiausia baigė savo amortizacijos ciklą, tai reiškia, kad neprarandate pinigų dėl jo vertės sumažėjimo.",
            stable: "Šiais metais išleidote €{costThisYear} palyginti su €{costLastYear} praėjusiais metais, tai yra {percent}% sumažėjimas. Prognozuojamos išlaidos matematiškai yra palankios.",
            costKm: "Praėjusiais metais nuvažiavote {km} km. Eksploatacijos išlaidos buvo €{costKm} už kilometrą, kas rodo puikų ekonominį efektyvumą.",
            fixedCosts: "Jūs sumokėjote €{costs} fiksuotų metinių išlaidų (draudimas/mokestis). Šis mažas pėdsakas suteikia papildomą ramybę.",
            usage: "Pagal jūsų užrašus, per metus nuvažiuojate apie {km} km.",
            practical_fit: "Praktinį tinkamumą įvertinote {score}/5, koreguodami matematinį balą {impact} taškais.",
            emotional_satisfaction: "Emocinį pasitenkinimą įvertinote {score}/5, koreguodami balą {impact} taškais.",
            reliability_anxiety: "Jūsų patikimumo pasitikėjimas yra {score}/5, paveikdamas balą {impact} taškais.",
            rust: "Sunkus struktūrinis ar pošalčio rūdijimas paprastai reiškia saugumo pavojus arba rašymo scenarijus.",
            accident: "Ankstesni pažeidimai, priklausomai nuo sunkumo, savaime sumažina transporto priemonės perpardavimo vertę ir saugumą.",
            structural: "Struktūrinės problemos automatiškai daro automobilį finansiškai pavojingu.",
            ai_lifespan: "Prie {current} km automobilis baigė {ratio}% savo AI numatomo gyvavimo trukmės ({expect} km).",
            ai_repairs: "AI duomenys rodo, kad {count} tipinių modelio specifinių didelių remontų paprastai įvyksta šioje ridai.",
            lifecycle_stage: "Ką reiškia gyvavimo trukmė? {total} km – tai yra AI numatytas taškas, kai dideli struktūriniai remontai (variklis, pavarų dėžė ir kt.) paprastai prasideda šiam modeliui. Tai nėra automobilio gyvenimo pabaiga – automobilis vis dar gali važiuoti, tačiau su žymiai didesnėmis priežiūros išlaidomis. Tipinio automobilio pilna fizinė gyvavimo trukmė yra 500k–1M km, tačiau jis tampa ekonomiškai neįmanomas daug anksčiau.",
        },
        ratios: {
            healthy: "Sveikas",
            monitor: "Stebėti",
            highRisk: "Aukšta rizika",
            stable: "Stabilus",
            warning: "Įspėjimas",
            financialStress: "Finansinis stresas",
        },
        proFeatureTitle: "Pro funkcija: Remonto režimas",
        proFeatureDesc: "Atblokavę sprendimų variklį, gausite profesionalią finansinę analizę apie savo transporto priemonės remontus. Nemokami vartotojai mato demonstraciją su pavyzdiniais duomenimis.",
        viewDemo: "Peržiūrėti gyvą demonstraciją",
        upgradeToUnlock: "Atsinaujinkite į PRO, kad analizuotumėte savo automobilį",
    },
    carTasks: {
        title: "Automobilio Užduotys",
        placeholderTitle: "Priežiūros Stebėjimas",
        placeholderDesc: "Priežiūros grafikas jūsų automobilio modeliui.",
        demoTitle: "Automobilio Priežiūros Užduotys",
        demoSubtitle: "Išmanus stebėjimas jūsų transporto priemonei",
        feature1Title: "Automatizuotas Užduočių Generavimas",
        feature1Desc: "Automatiškai generuoja užduotis, tokias kaip alyvos keitimas, filtrų keitimas ir diržo tikrinimas, remiantis jūsų automobilio modeliu.",
        feature2Title: "Išlaidų Integracija",
        feature2Desc: "Analizuoja jūsų serviso istoriją, kad suprastumėte, kas jau buvo padaryta ir kada.",
        feature3Title: "Išmanūs Primintuvai",
        feature3Desc: "Gaukite pranešimus remiantis tiek laiku, tiek rida. Stebėjimas automatiškai atnaujinamas, kai pažymite užduotį kaip atliktą.",
        getStarted: "Pradėti",
        fakeDoorPopupTitle: "Atsiliepimai Sveiki",
        fakeDoorPopupMessage: "Šiuo metu kuriame automobilio priežiūros užduotis. Ši funkcija leis jums automatiškai stebėti serviso intervalus. Kokias konkrečias užduotis ar funkcijas norėtumėte matyti labiausiai?",
        fakeDoorPopupPlaceholder: "Jūsų mintys...",
        noTasksYet: "Dar nėra užduočių",
        deleteAllTitle: "Išvalyti užduočių sąrašą?",
        deleteAllMessage: "Ar tikrai norite ištrinti visas {count} užduotis šiam automobiliui? Šio veiksmo negalima atšaukti.",
        deleteAllSuccess: "Visos užduotys buvo sėkmingai ištrintos.",
        sortPriority: "Prioritetas",
        sortType: "Tipas",
        sortDate: "Naujausios",
        status: {
            overdue: "PRANOKTA",
            pending: "LAUKIA",
            noData: "NĖRA DUOMENŲ",
            upcoming: "Artėja",
            nextIn: "Kita po {dist} {unit}",
            overdueBy: "{dist} {unit} praleista",
            afterDays: "Per {days} dienas",
            overdueDays: "{days} dienos praleistos",
        },
        form: {
            newTitle: "Nauja užduotis",
            actionType: "Patikrinti ar pakeisti?",
            intervalMonths: "Intervalas (Mėnesiai)",
            intervalDistance: "Intervalas (Atstumas)",
            diffFirstInterval: "Pirmasis intervalas skiriasi nuo pagrindinio intervalo",
            firstInterval: "Pirmasis intervalas",
            historyToggle: "Ar ši užduotis kada nors buvo atlikta šiam automobiliui?",
            historyToggleDesc: "Jei NE, mes manome, kad ji niekada nebuvo atlikta nuo gamybos.",
            lastPerformedOptional: "Kada ji buvo atlikta paskutinį kartą? (Pasirinktinai)",
            deleteTitle: "Ištrinti užduotį",
            deleteConfirm: "Ar tikrai norite ištrinti šią užduotį?",
            saveError: "Nepavyko išsaugoti užduoties",
            historyConfirmed: "Istorija patvirtinta",
            reminders: "Priminimai",
            notifyMileage: "Pranešti, kai bus pasiekta numatoma rida",
            notifyDate: "Pranešti, kai bus pasiekta data",
            nextMileageReminder: "Numatoma data",
            nextDateReminder: "Terminas",
            estimatedDate: "Numatoma data",
            missingLastMileage: "Trūksta paskutinio nuvažiuoto atstumo",
            missingLastDate: "Trūksta paskutinės atlikimo datos",
            missingStartDate: "Nepavyko nustatyti pradžios datos",
            additionalOptions: "Papildomos parinktys",
            reminderInfoMissing: "Informacinė būsena: priminimai yra išjungti, kol nebus pateikti paskutiniai atlikti duomenys.",
        },
    },
    dashboard: {
        title: "Apžvalga",
        quickActions: "Greitieji Veiksmai",
        addExpense: "Pridėti Išlaidą",
        editCar: "Redaguoti Automobilį",
        recentExpenses: "Naujausios Išlaidos",
        seeAll: "Žiūrėti viską",
        recentGallery: "Naujausios Nuotraukos",
        thisMonth: "Šį mėnesį",
        totalSpent: "Iš viso išleista",
        avgPerMonth: "Vid./mėn.",
        recentNotes: "Naujausi Užrašai",
        recentParts: "Naujausios Dalys",
        noRecentExpenses: "Nėra naujausių išlaidų",
        noRecentGallery: "Nėra naujausių nuotraukų",
        noRecentNotes: "Nėra naujausių užrašų",
        noRecentParts: "Nėra naujausių dalių",
        createNote: "Sukurti naują",
        createPart: "Sukurti naują",
        createExpense: "Sukurti naują",
        noFiles: "Dar nepridėta jokių failų",
        needSomethingMore: "Reikia kažko daugiau?",
        letUsKnow: "praneškite mums!",
    },
    expenseTypes: {
        editTitle: "Redaguoti išlaidų tipą",
        newTitle: "Naujas išlaidų tipas",
        categoryName: "Kategorijos pavadinimas",
        placeholderName: "pvz. Paslauga",
        signatureColor: "Parašo spalva",
        icon: "Kategorijos ikona",
        deleteConfirm: "Ar tikrai norite ištrinti tipą '{name}'?",
    },
    spareParts: {
        title: "Atsarginės dalys",
        connectedWithRecords: "Susiję su įrašais",
        toBuy: "Pirkti",
        usedInExpenses: "Naudota išlaidose",
        noPartsToBuy: "Nėra dalių pridėta į pirkinių sąrašą",
        noPartsUsed: "Nėra dalių, susijusių su išlaidomis",
        quantity: "Kiekis",
        partCode: "Dalis kodas",
        price: "Kaina",
        link: "Nuoroda",
        comment: "Komentaras",
        addPart: "Pridėti Atsarginę Dalių",
        editPart: "Redaguoti Atsarginę Dalių",
        openPart: "Atidaryti dalies įrašą",
        nameLabel: "Pavadinimas",
        manufacturerLabel: "Gamintojas",
        priceLabel: "Kaina ({currency})",
        imagesLabel: "Images & Files (first one is primary)",
        linkedHistory: "Susijusi Istorija",
        partManagedNote: "Ši dalis valdomas per išlaidą",
        cannotDeleteNote: "* Since this part is linked to an expense, it cannot be deleted separately. Delete or edit the expense to manage this part's lifecycle.",
        partNamePlaceholder: "Dalis pavadinimas...",
        manufacturerPlaceholder: "Bosch, Brembo, ir kt.",
        additionalInfoPlaceholder: "Papildoma informacija...",
        namePlaceholder: "pvz. Stabdžių trinkelės",
        codePlaceholder: "pvz. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Išsaugoti Dalių",
        deletePart: "Delete Part",
        deleteConfirm: "Ar tikrai norite ištrinti šią atsarginę dalį?",
        sparePartsLabel: "Atsarginės Dalių",
        partNumber: "Dalis #{number}",
        imagesLimitLabel: "Nuotraukos ir Failai (iki 5)",
        optional: "(neprivaloma)",
        selectPart: "Pasirinkti Atsarginę Dalių",
        createNew: "Sukurti naują atsarginę dalį",
        searchPlaceholder: "Ieškoti pagal pavadinimą arba kodą...",
        noResults: "Dalių nerasta",
        noPartsYet: "Dar nėra dalių. Sukurkite pirmąją!",
        selectorDescription: "Raskite ir pasirinkite esamą atsarginę dalį arba sukurkite naują",
        alreadyAdded: "Ši dalis jau pridėta",
        statistics: {
            avgPrice: "Vid.",
            lastPrice: "Paskutinė",
            usedTimes: "Naudota {count} kartų",
            totalPurchased: "Iš viso: {quantity}x",
        },
        usage: {
            title: "Šis Pirkimas",
            quantity: "Kiekis",
            pricePerUnit: "Kaina už vienetą",
            comment: "Komentaras",
            commentPlaceholder: "pvz., Pirktas AutoZone",
            total: "Iš viso",
            transactionData: "Ši Transakcija",
        },
        masterData: "Pagrindinė Dalies Informacija",
        masterRecord: {
            title: "Dalių Detalės (bendrinamos)",
            editMaster: "Redaguoti Pagrindinį Įrašą",
            warning: "Pakeitimai pagrindiniame įraše paveiks visas naudojimo atvejus",
        },
    },
    reminders: {
        title: "Priminimai",
        reminder: "Priminimas",
        noteReminder: "Pastabų priminimas",
        partReminder: "Detalių priminimas",
        today: "Šiandien",
        tomorrow: "Rytoj",
        yesterday: "Vakar",
        inXDays: "per {x} dienas",
        xDaysAgo: "prieš {x} dienas",
        inXMonths: "per {x} mėnesius",
        xMonthsAgo: "prieš {x} mėnesius",
        active: "Aktyvus",
        activeDesc: "Jei reikia, galite išjungti šį priminimą nepašalindami jo",
        disabled: "Išjungtas",
        yearly: "Metinis",
        markSeen: "Patvirtinti",
        addReminder: "Naujas priminimas",
        editReminder: "Redaguoti priminimą",
        extraReminders: "Papildomi priminimai",
        extraRemindersDesc: "Siųsti 3 papildomus priminimus kitomis dienomis (iš viso 4), jei nebus sustabdyta.",
        remindDate: "Data",
        remindTime: "Laikas",
        repeatYearly: "Kartoti kasmet",
        repeatYearlyDesc: "Šis priminimas automatiškai vyks kiekvienais metais tuo pačiu data/mėnesiu/diena/laiku, kol bus išjungtas",
        standalone: "Savarankiški priminimai",
        embedded: "Susieti priminimai",
        noReminders: "Nėra aktyvių priminimų",
        deleteReminder: "Ištrinti priminimą",
        nameLabel: "Pavadinimas",
        descriptionLabel: "Aprašymas",
        namePlaceholder: "Priminimo pavadinimas",
        descriptionPlaceholder: "Trumpas aprašymas arba pastaba",
        simulateReminder: "Simuliuoti priminimo momentą",
        simulateSuccess: "Simuliacijos el. paštas išsiųstas",
        timezone: "Laiko zona",
        nextReminder: "Kitas priminimas",
        futureTimeError: "Priminti laikas turi būti ateityje",
    },
    notes: {
        title: "Užrašai",
        emptyNote: "Tuščias užrašas",
        noNotes: "Dar nėra užrašų",
        addNote: "Pridėti Užrašą",
        editNote: "Redaguoti Užrašą",
        viewNote: "Peržiūrėti Užrašą",
        openNote: "Atidaryti užrašo įrašą",
        titleLabel: "Pavadinimas",
        contentLabel: "Turinys",
        noteTitlePlaceholder: "Užrašo pavadinimas...",
        noteContentPlaceholder: "Rašykite savo užrašą čia...",
        saveNote: "Išsaugoti Užrašą",
        deleteNote: "Ištrinti Užrašą",
        publicNote: "Padaryti užrašą viešą",
        publicNoteDesc: "Kiti gali peržiūrėti šį užrašą per bendrinamą nuorodą",
        deleteConfirm: "Ar tikrai norite ištrinti šį užrašą?",
        enterTitleAlert: "Prašome įvesti pavadinimą",
        saveFailed: "Nepavyko išsaugoti užrašo",
        thisNote: "Šis užrašas",
        deleteFailed: "Nepavyko ištrinti užrašo",
        pinToTop: "Prisegti prie viršaus",
    },
    locations: {
        title: "Vietos",
        singleTitle: "Vieta",
        newLocation: "Nauja vieta",
        emptyLocation: "Tuščia vieta",
        noLocations: "No locations yet",
        addLocation: "Pridėti vietą",
        editLocation: "Redaguoti vietą",
        viewLocation: "Peržiūrėti vietą",
        openLocation: "Atidaryti vietą",
        createNew: "Sukurti naują vietą",
        selectLocation: "Pasirinkti vietą",
        searchLocations: "Ieškoti vietų...",
        nameLabel: "Pavadinimas",
        addressLabel: "Adresas arba Koordinatės",
        descriptionLabel: "Komentaras/Aprašymas",
        namePlaceholder: "pvz., Centro servisas",
        mapLabel: "Vieta",
        searchPlaceholder: "Ieškoti adreso...",
        addressPlaceholder: "Įveskite adresą ir pasirinkite...",
        descriptionPlaceholder: "Papildoma informacija...",
        fillAddress: "Užpildyti adresą iš žemėlapio",
        saveLocation: "Išsaugoti vietą",
        deleteLocation: "Ištrinti vietą",
        deleteConfirm: "Ar tikrai norite ištrinti šią vietą?",
        enterNameAlert: "Prašome įvesti pavadinimą",
        saveFailed: "Nepavyko išsaugoti vietos",
        thisLocation: "Ši vieta",
        deleteFailed: "Nepavyko ištrinti vietos",
        myLocations: "Mano vietos",
        usedInEntries: "Naudota įrašuose",
        noEntries: "Vieta nenaudojama",
        noEntriesThisCar: "Ši vieta nebuvo naudojama šiam automobiliui",
        removeLocation: "Pašalinti vietą",
        noResults: "Nerasta rezultatų",
    },
    gallery: {
        title: "Gallery",
        noImages: "Nuotraukų nepridėta",
        addImagesNote: "Pridėti nuotraukas prie automobilio ar išlaidų",
        totalImages: "Iš viso {count} nuotraukų",
        imageAlt: "Nuotrauka {number}",
        commentPlaceholder: "Failo komentaras",
        isReceipt: "Šis failas yra kvitas",
        deleteImageTitle: "Ištrinti failą",
        deleteImageConfirm: "Ar tikrai norite visam laikui ištrinti šį failą?",
    },
    search: {
        placeholder: "Ieškoti išlaidų, dalių, užrašų...",
        typeToSearch: "Įrašykite, kad pradėtumėte ieškoti",
        noResults: "Nerasta rezultatų '{query}'",
        carImage: "Automobilio Nuotrauka",
        expenseImage: "Išlaidų Nuotrauka",
        noteImage: "Užrašo Nuotrauka",
        galleryImage: "Galerijos Nuotrauka",
        untitledExpense: "Be pavadinimo Išlaida",
    },
    landing: {
        nav: {
            features: "Funkcijos",
            howItWorks: "Kaip tai veikia",
            pricing: "Kainos",
            login: "Prisijungti",
            getStarted: "Pradėti",
            garage: "Garažas",
        },
        hero: {
            title: "Žinokite, kiek tiksliai kainuoja jūsų automobilis",
            subtitle: "Iš tiesų",
            description: "Sekite išlaidas, registruokite remontus ir matykite, kur iš tikrųjų išeina jūsų pinigai.",
            subheadline: "Profesionali duomenimis paremta informacijos lenta kruopštiems automobilių savininkams.",
            startTracking: "Pradėti",
            viewDemo: "Demonstruoti automobilį ->",
            trustSignal: "Prisijunkite prie 1,200+ kruopščių savininkų, kurie jau užfiksavo daugiau nei 5 milijonus kilometrų realių automobilių išlaidų.",
            ctaNote: "Be kredito kortelės. Be įkyrių pardavimų. Tik aiškumas.",
            benefits: {
                repairVsSell: {
                    title: 'Raskite "Remontuoti ar Parduoti" slenkstį',
                    description: 'Nustokite spėlioti, ar investuojate į "duobę be dugno". Žinokite tikslų momentą, kada remontas nebeapsimoka.'
                },
                costPerKm: {
                    title: 'Stebėkite realią CPK (kaina už km)',
                    description: 'Pamatykite visą finansinį vaizdą apie savo vairavimo įpročius, kurį kitos programėlės praleidžia.'
                },
                automation: {
                    title: 'Automatizuokite savo apskaitą',
                    description: 'Tiesiog persiųskite savo sąskaitas el. paštu. Mūsų AI sutvarkys jūsų automobilio techninę istoriją už jus.'
                }
            }
        },
        features: {
            title: "Viskas, ko reikia jūsų automobiliui valdyti",
            subtitle: "Nustokite naudoti skaičiuokles ir netvarkingus papildus. „My Car Costs“ suteikia profesionalius parko valdymo įrankius jūsų asmeniniam garažui.",
            expenseTracking: {
                title: "Išlaidų sekimas",
                description: "Registruokite degalus, servisą, draudimą ir remontą. Kategorizuokite išlaidas ir vizualizuokite tendencijas.",
            },
            spareParts: {
                title: "Atsarginių dalių valdytojas",
                description: "Turėkite detalų atsarginių dalių, kodų ir suderinamumo pastabų inventorių visiems remontams.",
            },
            serviceHistory: {
                title: "Serviso istorija ir pastabos",
                description: "Turėkite skaitmeninę serviso knygelę. Pridėkite detalias pastabas apie priežiūrą, modifikacijas ar ateities planus.",
            },
            documentStorage: {
                title: "Dokumentų saugykla",
                description: "Įkelkite kvitus, sąskaitas ir automobilio nuotraukas. Laikykite dokumentus saugiai ir pasiekiamai.",
            },
            emailForwarding: {
                title: "El. pašto persiuntimas",
                description: "Persiųskite sąskaitas tiesiai į savo unikalią dėžutę. Mes automatiškai ištrauksime datus.",
            },
            multiCar: {
                title: "Kelių automobilių garažas",
                description: "Valdykite vieną automobilį ar visą parką. Persijunkite tarp transporto priemonių akimirksniu.",
            },
            repeatingExpenses: {
                title: "Kartojančios išlaidos",
                description: "Automatizuokite reguliarių mėnesinių išlaidų, tokių kaip draudimas, parkavimas ar nuoma, sekimą.",
            },
            smartReminders: {
                title: "Išmanūs priminimai",
                description: "Nustatykite pasirinktinius įspėjimus dėl atsarginių dalių ir paslaugų pastabų, kad niekada nepraleistumėte priežiūros užduoties.",
            },
        },
        howItWorks: {
            title: "Paprasta ir galinga eiga",
            step1: {
                title: "Pridėkite savo automobilį",
                description: "Įveskite savo automobilio duomenis, kad sukurtumėte savo skaitmeninį garažą.",
            },
            step2: {
                title: "Registruokite išlaidas ir failus",
                description: "Nufotografuokite kvito nuotrauką arba persiųskite el. laišką. Mes pasirūpinsime likusia dalimi.",
            },
            step3: {
                title: "Gaukite įžvalgas",
                description: "Matykite savo kainą už kilometrą, mėnesio išlaidas ir priežiūros laiko juostą.",
            },
        },
        useCases: {
            title: "Puikiai tinka",
            enthusiasts: {
                title: "Automobilių entuziastams",
                description: "Sekite kiekvieną modifikaciją, dalies numerį ir priežiūros intervalą savo projektui.",
            },
            dailyDrivers: {
                title: "Kasdieniams vairuotojams",
                description: "Žinokite tiksliai, kiek kainuoja jūsų kelionė, ir niekada nepraleiskite serviso datos.",
            },
            flippers: {
                title: "Išmanusis perpardavėjas",
                description: "Sukurkite patikimą duomenų kiekį, kuris įrodytų jūsų automobilio tikrąją vertę pirkėjams.",
            },
            fleets: {
                title: "Mažiems parkams",
                description: "Valdykite kelias įmonės transporto priemones vienoje vietoje be sudėtingos programinės įrangos.",
            },
        },
        foundersNote: {
            title: "Įkūrėjo pastaba",
            content: "Kuriu MyCarCosts, kad tai būtų galutinis įrankis žmonėms, kurie iš tikrųjų rūpinasi savo automobiliais. Ar jūsų darbo sraute trūksta kokios nors funkcijos? Susisiekite su manimi tiesiogiai. Jei tai turi prasmę bendruomenei, mes ją sukursime kartu.",
        },
        pricing: {
            freeLimitedTime: "Nemokamai ribotą laiką",
            title: "Paprasta ir skaidri kainodara",
            subtitle: "Pradėkite nemokamai, atnaujinkite augdami.",
            perMonth: "mėn.",
            monthly: "Mėnesinis",
            yearly: "Metinis",
            save25: "Išsaugokite 25%",
            billedAnnually: "Apmokama kasmet ({amount})",
            free: {
                title: "Nemokamas",
                cta: "Pradėti",
            },
            pro: {
                title: "Pro",
                cta: "Atnaujinti į Pro",
                recommended: "Rekomenduojama",
                earlyAdopter: "Ankstyvojo naudotojo kaina",
                priceLock: "Užfiksuokite šią kainą dabar. Ateityje kaina gali kilti.",
            },
            custom: {
                title: "Custom",
                cta: "Susisiekite su mumis",
            },
            features: {
                oneCar: "1 automobilis",
                unlimitedExpenses: "Neribotos išlaidos",
                unlimitedSpareParts: "Neribotos atsarginės dalys",
                unlimitedNotes: "Neribotos pastabos",
                repeatedExpenses: "Kartojančios išlaidos",
                emailReminders: "Pastabų ir atsarginių dalių el. priminimai",
                basicStatistics: "Pagrindinė statistika",
                fullStatistics: "Išsami statistika",
                storage50mb: "50 Mb failų saugojimas",
                unlimitedArchivedCars: "Neriboti archyvuoti automobiliai",
                dataExport: "Duomenų eksportavimas",
                allInFreePlus: "viskas nemokamai plius:",
                threeCars: "Iki 3 automobilių",
                storage2gb: "2 Gb failų saugojimas",
                emailParsing: "El. pašto analizė",
                carAdmins: "Automobilio administratoriai",
                moreCars: "Daugiau automobilių",
                moreFileStorage: "Daugiau failų saugojimo",
                customRequirements: "Individualūs reikalavimai",
            },
            upgradePopup: {
                title: "Greitai!",
                message: "Pro ir pritaikytos versijos dar nebuvo paleistos, tačiau jos bus greitai. Norėdami padėti mums greičiau paleisti - prašome užsirašyti, kokios konkrečios funkcijos tikitės iš pro / pritaikytos versijos, arba bet ką kitą, ką norėtumėte, kad patobulintume, kad ši platforma būtų dar geresnė jums!",
                placeholder: "Rašykite savo atsiliepimus čia...",
                submit: "Siųsti",
                cancel: "Atšaukti",
                thanksTitle: "Ačiū!",
                thanksMessage: "Gavome jūsų atsiliepimus ir dirbsime, kad MyCarCosts būtų dar geresnis!",
                thanksOk: "Gerai",
            },
        },
        migration: {
            title: "Pereinate iš Excel ar kitos programėlės?",
            subtitle: "Siūlome profesionalią duomenų migravimo paslaugą, kad galėtumėte pradėti akimirksniu.",
            pricingModel: "Kainodaros modelis",
            small: {
                title: "Mažas duomenų rinkinys",
                description: "< 500 eilučių",
                price: "19–29 $",
            },
            medium: {
                title: "Vidutinis duomenų rinkinys",
                description: "500–5,000 eilučių",
                price: "49 $",
            },
            large: {
                title: "Didelis / Sudėtingas",
                description: "Pasenusios sistemos ar sudėtingi failai",
                price: "Individualus pasiūlymas",
            },
            process: {
                title: "Kaip tai veikia",
                step1: "Jūs pateikiate savo failą",
                step2: "Mes įvertiname duomenis",
                step3: "Vienkartinis mokėjimas",
                step4: "Mes atliekame importą",
            },
            cta: "Užsakyti migraciją",
        },
        repairAnalysisSection: {
            title: "Remontuoti ar parduoti? Leiskite duomenims nuspręsti.",
            subtitle: "Profesionali finansinė analizė jūsų transporto priemonei. Nustokite spėlioti ir pradėkite žinoti, ar tie remontai tikrai verti.",
            features: {
                personalized: {
                    title: "Pritaikyta analizė",
                    description: "Jūsų sekamiems automobiliams naudojame realius istorinius išlaidas ir parametrus, pridėdami planuojamas išlaidas, kad sukurtume vertinimą.",
                },
                public: {
                    title: "Viešasis simuliatorius",
                    description: "Vertinate potencialų pirkimą? Naudokite mūsų viešą įrankį adresu /repair, kad sukurtumėte išsamią analizę, įvesdami tik kelis pagrindinius duomenis.",
                },
                whatIf: {
                    title: "Kas-jei simuliatorius",
                    description: "Įveskite planuojamą remonto kainą ir akimirksniu pamatykite, kaip tai paveikia jūsų automobilio finansinį balą.",
                },
            },
            cta: "Peržiūrėti pavyzdinę analizę",
        },
        faq: {
            title: "Dažniausiai užduodami klausimai",
            subtitle: "Viskas, ką jums reikia žinoti apie My Car Costs",
            questions: {
                mobileApps: {
                    question: "Ar bus programos iOS ir Android?",
                    answer: "Taip! Greitai pasirodys mobiliosios programos tiek iOS, tiek Android įrenginiams. Mes sunkiai dirbame, kad suteiktume jums geriausią mobiliąją patirtį.",
                },
                dataPrivacy: {
                    question: "Ar mano duomenys yra privatūs ir saugūs?",
                    answer: "Visiškai. Jūsų duomenys yra užšifruoti ir saugomi saugiai.",
                },
                freePlan: {
                    question: "Ar nemokamas planas tikrai nemokamas visam laikui?",
                    answer: "Taip! Nemokamas planas visada bus prieinamas vienam automobiliui. Galite bet kada atnaujinti į Pro planą iki 3 automobilių.",
                },
                dataExport: {
                    question: "Ar galiu eksportuoti savo duomenis?",
                    answer: "Taip, galite bet kada eksportuoti visus savo duomenis CSV arba PDF formatu.",
                },
                emailImport: {
                    question: "Kaip veikia el. pašto importavimas?",
                    answer: "Kiekvienas automobilis gauna unikalų el. pašto adresą. Tiesiog persiųskite savo sąskaitas ir mes ištrauksime datus.",
                },
                multipleUsers: {
                    question: "Ar keli žmonės gali pasiekti tą patį automobilį?",
                    answer: "Šiuo metu kiekvienas automobilis priklauso vienai paskyrai. Tačiau galite padaryti automobilį viešai matomą kitiems.",
                },
            },
        },
        cta: {
            title: "Nustokite spėlioti. Pradėkite žinoti.",
            subtitle: "Paverskite savo automobilio istoriją aiškiais finansiniais sprendimais. Prisijunkite prie tūkstančių išmaniųjų savininkų, kurie tiksliai žino, kada investuoti ar parduoti.",
            button: "Pradėkite dabar",
            note: "Be kredito kortelės. Be įkyrių pardavimų. Tik aiškumas.",
        },
        footer: {
            product: "Produktas",
            legal: "Teisinė informacija",
            changelog: "Pakeitimų žurnalas",
            privacy: "Privatumo politika",
            contact: "Kontaktai",
            contactEmail: "info@mycarcosts.com",
            questions: "Klausimų? Susisiekite su mumis adresu:",
        },
        privacy: {
            title: "Privatumo politika",
            lastUpdated: "Atnaujinta: 2026 m. kovo 25 d.",
            introduction: "„My Car Costs“ mes rimtai žiūrime į jūsų privatumą. Ši politika paaiškina, kaip mes tvarkome jūsų duomenis.",
            dataCollection: {
                title: "Duomenų rinkimas",
                description: "Mes renkame tik absoliučiai minimalų informaciją, reikalingą mūsų paslaugai teikti.",
                email: "Paskyros tapatybė: Mes naudojame jūsų el. pašto adresą kaip unikalų identifikatorių ir autentifikacijai (pvz., magiški nuorodos arba Google prisijungimas).",
                documents: "Dokumentų saugojimas: Failai, kuriuos įkelsite, saugomi saugiai užšifruotoje debesų saugykloje.",
            },
            carData: {
                title: "Jūsų duomenų kontrolė",
                description: "Informacija, kurią įvedate (išlaidos, rida, dalys), saugoma jūsų asmeniniam naudojimui ir analizei.",
                noValidation: "Mes nepatvirtiname jūsų pateiktų automobilių duomenų; jūsų atsakomybė yra užtikrinti tikslumą.",
                privateByDefault: "Pagal numatytuosius nustatymus jūsų duomenys yra privatūs. Techniniai failų identifikatoriai yra nenumeruoti ir nėra indeksuojami paieškos sistemų.",
                rightToForgotten: "Teisė būti pamirštam: Bet kuriuo metu galite ištrinti savo paskyrą, kas iš karto ir visam laikui pašalina visus jūsų įrašus ir failus.",
            },
            thirdParty: {
                title: "Trečiųjų šalių paslaugos",
                description: "Mes neparduodame jūsų asmeninių duomenų. Naudodamiesi „Google“ prisijungimu, mes tik pasiekiame jūsų el. pašto adresą identifikavimo tikslais.",
            },
            emailIngestion: {
                title: "El. pašto priėmimas",
                description: "El. laiškai, siunčiami mūsų priėmimo paslaugai, saugomi siekiant pateikti apdorojimo istoriją. Bet kada galite rankiniu būdu ištrinti atskirus el. laiškus arba visą savo istoriją.",
            },
        },
        emails: {
            deleteAll: "Ištrinti viską",
            deleteAllConfirm: "Ar tikrai norite ištrinti visą šio automobilio el. pašto istoriją? Šis veiksmas yra negrįžtamas.",
            deleteConfirm: "Ar tikrai norite ištrinti šį el. laišką?",
            noEmails: "Dar negauta jokių el. laiškų.",
        },
        terms: {
            title: "Taisyklės ir sąlygos",
            lastUpdated: "Atnaujinta: 2026 m. kovo 25 d.",
            introduction: "Naudodamiesi „MyCarCosts“ paslaugomis, sutinkate laikytis šių Taisyklių ir sąlygų. Jei nesutinkate, prašome nesinaudoti mūsų paslauga.",
            acceptance: {
                title: "1. Sąlygų priėmimas",
                description: "Šios sąlygos sudaro teisiškai įpareigojantį susitarimą tarp jūsų ir „MyCarCosts“ dėl naudojimosi mūsų programėle ir paslaugomis.",
            },
            service: {
                title: "2. Paslaugos aprašymas",
                description: "„MyCarCosts“ teikia platformą transporto priemonių išlaidų sekimui, priežiūros valdymui ir finansinei analizei. Tai apima dirbtiniu intelektu pagrįstą kvitų analizę ir duomenų vizualizavimo įrankius.",
            },
            responsibilities: {
                title: "3. Vartotojo atsakomybė",
                description: "Esate atsakingi už visų įvedamų duomenų, įskaitant ridą, VIN numerius ir išlaidas, tikslumą. Privalote saugoti savo prisijungimo duomenis (el. paštą / magišką nuorodą) ir nesidalinti jais su neįgaliotomis šalimis.",
            },
            plans: {
                title: "4. Paslaugų planai ir limitai",
                description: "Siūlome nemokamus ir „Pro“ planus su skirtingais saugyklos, automobilių skaičiaus ir įkėlimų limitais. Pasiliekame teisę bet kada keisti šiuos limitus arba įvesti naujus prenumeratos lygius.",
            },
            disclaimer: {
                title: "5. Atsakomybės apribojimas ir tikslumas",
                description: "„MyCarCosts“ yra informacinis ir organizacinis įrankis. Mes neteikiame oficialių transporto priemonės būklės sertifikatų. Vartotojas visada turėtų patikrinti dirbtinio intelekto analizuotų kvitų duomenų tikslumą.",
            },
            liability: {
                title: "6. Atsakomybės ribojimas",
                description: "„MyCarCosts“ paslauga teikiama tokia, kokia yra („as-is“). Mes neatsakome už jokius mechaninius gedimus, finansinius nuostolius ar duomenų netikslumus, atsiradusius naudojantis mūsų programėle.",
            },
            termination: {
                title: "7. Paslaugos nutraukimas",
                description: "Galite bet kada nustoti naudotis paslauga ir ištrinti savo duomenis. Pasiliekame teisę sustabdyti arba panaikinti paskyras, kurios pažeidžia šias sąlygas arba piktnaudžiauja paslauga.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

